module.exports = __webpack_public_path__ + "023.6ecac0d6.png";